import { Component, computed, Inject, input, signal } from '@angular/core';
import { DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { AnalogIn, AnalogOut, DigitalIn, DigitalOut, LosDefType, ModuleLosdef, ModulePayload, RangedKanaal, RangedKanaalAssign } from '../../props/PropTypes';
import { clipboardIcon, arrowRightIcon } from "@progress/kendo-svg-icons";
import { KopConfigService } from '../../core/kop-config.service';
import { KanaalService } from '../kanaal.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { cAfdelingWM, cKC_Afdeling } from '@wasm/KopWeb';
import { KopModulesService } from '../../modules/kop-modules.service';
import { AfdMeta } from '../../core/meta.service';
import { ModulesRepoService } from '../../modules/modules-repo.service';
import { TranslateService } from '../../i18n/translate.service';
import { AfdModule } from '@etron/typings';
import { HwdConfigService } from '../hwd-config.service';

@Component({
  selector: 'paste',
  templateUrl: './paste.component.html',
  styles: `
  .main-wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 3px;
  }
  .row {
    display: flex;
    flex-direction: row;
    column-gap: 3px;
    align-items: center;
    justify-content: start;
  }
  .label {
    font-weight: bold;
    width: 150px;
    text-align: end;
  }

  `
})
export class PasteComponent {

  public pasteIcon = clipboardIcon;
  public moveIcon = arrowRightIcon;

  constructor(private kopConfigService: KopConfigService, private kanaalService: KanaalService,
    private jsBridgeService: JSBridgeService, private kopModulesService: KopModulesService,
    @Inject('i18n-label') private i18nLabel: any,
    private moduleRepo: ModulesRepoService, private dialogService: DialogService, private translateService: TranslateService,
    private hwdConfigService: HwdConfigService) {
  }

  public showDialog = false;

  public title: string = "";

  public aiRange?: RangedKanaal;
  public aoRange?: RangedKanaal;
  public diRange?: RangedKanaal;
  public doRange?: RangedKanaal;

  private oldKanalen: RangedKanaalAssign[] = [];
  private kanalen: RangedKanaalAssign[] = [];
  private newAfd: cKC_Afdeling | undefined;

  public isModule = false;
  public pastedModule: AfdModule | undefined;

  public currentAfd = input<cAfdelingWM | undefined>(undefined);
  public dialogTitle = input<string>("Paste Kanaal");

  public isMove = computed(() => {
    return this.currentAfd() != undefined;
  });

  async onMove() {
    let afd = this.currentAfd();
    if (afd != undefined) {
      this.newAfd = afd.afdeling();
      this.kanalen = this.kanaalService.getAfdelingKanalen(this.newAfd);
      let kfg = this.jsBridgeService.getBridgeSync().getConfig();
      this.oldKanalen = this.kanaalService.getKonfigKanalen(kfg);
      // this.kopConfigService.refresh();
      // this.prepareMove();
      this.aiRange = this.hwdConfigService.getCurrentRange(this.kanalen, AnalogIn);
      this.aoRange = this.hwdConfigService.getCurrentRange(this.kanalen, AnalogOut);
      this.diRange = this.hwdConfigService.getCurrentRange(this.kanalen, DigitalIn);
      this.doRange = this.hwdConfigService.getCurrentRange(this.kanalen, DigitalOut);
      this.showDialog = true;
    }
  }

  private prepareMove() {
    if (this.newAfd != undefined) {
      let kfg = this.jsBridgeService.getBridgeSync().getConfig();
      this.oldKanalen = this.kanaalService.getKonfigKanalen(kfg);

      this.kopConfigService.refresh(false);
      this.aiRange = this.hwdConfigService.getRangedStart(this.oldKanalen, this.kanalen, AnalogIn);
      this.aoRange = this.hwdConfigService.getRangedStart(this.oldKanalen, this.kanalen, AnalogOut);
      this.diRange = this.hwdConfigService.getRangedStart(this.oldKanalen, this.kanalen, DigitalIn);
      this.doRange = this.hwdConfigService.getRangedStart(this.oldKanalen, this.kanalen, DigitalOut);
    }
  }


  private processLosDef(losdef: ModuleLosdef, ldType: LosDefType, cmeta: AfdMeta) {
    let ldMeta = cmeta.losDefRaw.find(ld => ld.index == losdef.index);
    let ret: RangedKanaalAssign[] = [];
    if (ldMeta != undefined) {
      let type = this.kanaalService.getIOTypeFromParamType(ldMeta.type);
      if (type != undefined && losdef.waarde != undefined && losdef.range != undefined) {
        let tmp: RangedKanaalAssign = {
          rangedKnaal: { ioType: type, start: losdef.waarde, range: losdef.range },
          assignement: {
            type: ldType,
            index: losdef.index,
            omschrijving: "",
            afdeling: this.newAfd!.titel,
            afdRefNr: this.newAfd!.refNr,
            key: ""
          }
        };
        ret.push(tmp);

      }
      this.kopConfigService.upsertLosDef(losdef, ldType);
    }
    return ret;

  }

  async pasteModule(jsonStr: string) {
    let payload: ModulePayload = JSON.parse(jsonStr);
    let afdWM = this.kopConfigService.selectedAfd();
    if (afdWM != undefined && payload.meta != undefined) {
      this.newAfd = afdWM.afdeling();
      this.pastedModule = payload.meta;
      let afdType = this.newAfd.type;
      let key = this.moduleRepo.typeMap()[afdType.value];
      let canPaste = payload.meta.meta.supportedAfdelingTypes.indexOf(key) >= 0;
      if (!canPaste) {
        this.dialogService.open({
          title: await this.translateService.getTranslation(this.i18nLabel, "Error", "Error"),
          content: await this.translateService.getTranslation(this.i18nLabel, "De gekozen afdeling is niet compatibel met het plakken module", "De gekozen afdeling is niet compatibel met het plakken module"),
          actions: [{ text: "Close", themeColor: "primary" }],
        });
        return;
      }
      let afdWMM = this.kopModulesService.afdelings()[this.newAfd.uuid];
      if (afdWMM != undefined) {
        canPaste = afdWMM.modules.find(m => m.meta.key == payload.meta.meta.key) == undefined;
        if (!canPaste) {
          this.dialogService.open({
            title: await this.translateService.getTranslation(this.i18nLabel, "Error", "Error"),
            content: await this.translateService.getTranslation(this.i18nLabel, "Er bestaat al een module: ", "Er bestaat al een module: ") + payload.meta.meta.name,
            actions: [{ text: "Close", themeColor: "primary" }],
          });
          return;
        }
      }

      this.kanalen = [];
      let cmeta = this.kopConfigService.currentMeta();

      for (let aim of payload.ais) {
        this.kanalen.push({
          rangedKnaal: {
            ioType: AnalogIn,
            start: aim.kanaal,
            range: aim.range
          },
          assignement: {
            type: 'ai',
            index: aim.index,
            omschrijving: "",
            afdeling: this.newAfd!.titel,
            afdRefNr: this.newAfd!.refNr,
            key: ""
          }
        });
        this.kopConfigService.upsertAI(aim);
      }

      for (let servo of payload.servos) {
        let servoMeta = cmeta.servos.find(s => s.index == servo.index);
        if (servoMeta != undefined) {
          let type = this.kanaalService.getServoKanaalType(servo);
          if (type != undefined) {
            this.kanalen.push({
              rangedKnaal: type,
              assignement: {
                type: 'servo',
                index: servo.index,
                omschrijving: "",
                afdeling: this.newAfd!.titel,
                afdRefNr: this.newAfd!.refNr,
                key: ""
              }
            });
          }
          for (let [no, param] of Object.entries(servo.params)) {
            let type = this.kanaalService.getIOTypeFromParamType(param?.type);
            if (type != undefined) {
              let tmp: RangedKanaalAssign = {
                rangedKnaal: { ioType: type, start: param.waarde, range: param.range },
                assignement: {
                  type: 'servoparam',
                  index: parseInt(no),
                  omschrijving: "",
                  afdeling: this.newAfd!.titel,
                  afdRefNr: this.newAfd!.refNr,
                  key: ""
                }
              };
              this.kanalen.push(tmp);

            }
          }
          this.kopConfigService.upsertServo(servo, servoMeta);
        }
      }
      for (let losdef of payload.losdefs) {
        let assigns = this.processLosDef(losdef, 'losdef', cmeta);
        this.kanalen = this.kanalen.concat(assigns);
      }
      for (let verwarming of payload.verwarmings) {
        let assigns = this.processLosDef(verwarming, 'verwarming', cmeta);
        this.kanalen = this.kanalen.concat(assigns);
      }
      for (let koeling of payload.koelings) {
        let assigns = this.processLosDef(koeling, 'koeling', cmeta);
        this.kanalen = this.kanalen.concat(assigns);
      }
      for (let droogwand of payload.drogWands) {
        let assigns = this.processLosDef(droogwand, 'droogwand', cmeta);
        this.kanalen = this.kanalen.concat(assigns);
      }
      this.kopModulesService.paste(this.newAfd.uuid.toString(), [payload.meta], false);

      if (this.kanalen.length > 0) {
        this.prepareMove();
        this.showDialog = true;
      }

    }

  }

  private getTitle() {
    if (this.newAfd != undefined) {
      let tempTitle = this.newAfd.titel.toString();
      let allAfd = this.kopConfigService.afdelings();
      let thisAfdUUID = this.newAfd.uuid.toString();
      for (let afdWM of allAfd) {
        let afd = afdWM.afdeling();
        let afdUUID = afd.uuid.toString();
        if (afd.titel.toString() == tempTitle && afdUUID != thisAfdUUID) {
          console.log("duplicate title");
          tempTitle = tempTitle + "_";
          break;
        }
      }
      return tempTitle.substring(0, 8);
    }
    return "";

  }

  async onPaste() {
    let pasteStr = await navigator.clipboard.readText();
    if (pasteStr != undefined && pasteStr.length > 0) {
      if (this.kopConfigService.isDetail()) {
        this.isModule = true;
        this.pasteModule(pasteStr);
      } else {
        this.isModule = false;
        let regex = /<modules>(.*?)<\/modules>/;
        let match = pasteStr.match(regex);
        let modulesJSON = undefined;
        if (match != null && match.length > 1) {
          console.log("match", match);
          modulesJSON = match[1];
          pasteStr = pasteStr.replace(match[0], "");
        }


        this.newAfd = this.kopConfigService.addAfdFromXML(pasteStr);
        if (modulesJSON != undefined && this.newAfd != undefined) {
          try {
            let modules = JSON.parse(modulesJSON);
            this.kopModulesService.paste(this.newAfd.uuid.toString(), modules);

          } catch (e) {
            console.log(e);
          }
        }
        if (this.newAfd != undefined) {
          this.kanalen = this.kanaalService.getAfdelingKanalen(this.newAfd);
          this.prepareMove();


          this.title = this.getTitle();
          this.showDialog = true;
        }
      }
    }
  }


  onConfirmAction() {

    if (this.newAfd != undefined) {

      if (this.aiRange != undefined) {
        let newMinMax = this.kanaalService.findMinMaxKanaal(this.kanalen, AnalogIn);
        let offset = this.aiRange.start - newMinMax.min;
        if (offset % 2 == 1) {
          offset++;
        }
        this.kopConfigService.reNumberKanalen(this.oldKanalen, this.kanalen, this.newAfd, AnalogIn, offset);
      }
      if (this.aoRange != undefined) {
        let newMinMax = this.kanaalService.findMinMaxKanaal(this.kanalen, AnalogOut);
        let offset = this.aoRange.start - newMinMax.min;
        this.kopConfigService.reNumberKanalen(this.oldKanalen, this.kanalen, this.newAfd, AnalogOut, offset);
      }

      if (this.diRange != undefined) {
        let newMinMax = this.kanaalService.findMinMaxKanaal(this.kanalen, DigitalIn);
        let offset = this.diRange.start - newMinMax.min;
        this.kopConfigService.reNumberKanalen(this.oldKanalen, this.kanalen, this.newAfd, DigitalIn, offset);
      }

      if (this.doRange != undefined) {
        let newMinMax = this.kanaalService.findMinMaxKanaal(this.kanalen, DigitalOut);
        let offset = this.doRange.start - newMinMax.min;
        this.kopConfigService.reNumberKanalen(this.oldKanalen, this.kanalen, this.newAfd, DigitalOut, offset);
      }
      if (this.currentAfd() == undefined && !this.isModule) {
        this.newAfd.titel = this.title;

      }
    }
    if (this.newAfd != undefined) {
      this.kopConfigService.selectAfdeling(this.newAfd.refNr);
    }
    this.showDialog = false;
  }


  onCancel() {
    if (!this.isMove() && (this.newAfd != undefined) && (!this.isModule)) {
      this.kopConfigService.removeAfd(this.newAfd?.refNr);
    }
    if (this.isModule && this.pastedModule != undefined) {
      this.kopModulesService.deleteModule(this.pastedModule, true);
    }
    this.showDialog = false;
  }
}
